const createRangeParam = array => {
  return array.map(x => { return { start: x.start, end: x.end }})
}

// Apiへ送る用のパラメータを作成
const createApiConditionParam = (state, getters) => {
  // 共通部分をまずは作成
  const params = {
    conversions: state.checkedArr.eiwa.map(v => v-1),
    speechPartIds: state.checkedArr.hinshi,
    options: state.checkedArr.target.map(v => v-1),
    wordCountAttributes: getters.sendWordCountAttributes,
    order: state.selectedQuestionSortType,
    explanation: state.selectedQuestionDescription === 1 ? true : false
  }

  // あとは条件によって変わる部分を調整していく

  // 応用問題か
  if (getters.isCategoryAdvanced) {
    Object.assign(params, { inflectionalFormIds: state.checkedArr.katsuyo })
    Object.assign(params, { sentences: state.checkedArr.reibun.map(v => v-1) })
    Object.assign(params, { opposite: state.checkedArr.hanigo.length > 0 ? true : false })
  }

  // 応用問題で活用形
  // if (getters.isCategoryAdvanced && state.checkedArr.reibun.length === 0 && (state.checkedArr.katsuyo.length !== 0)) {
  //   Object.assign(params, { options: [] })
  // }

  // ページ指定か
  if (getters.selectedRangeTypeIsPage) {
    // 単語か例文が選択されているか
    if (getters.isShowPagesTango) {
      Object.assign(params, { pageRanges: createRangeParam(getters.wasInputTangoRangePages) })
    }
    // 連語か例文が選択されているか
    if (getters.isShowPagesRengo) {
      Object.assign(params, { compoundPageRanges: createRangeParam(getters.wasInputRengRangePages) })
    }

    // 応用問題で活用形と反意語のみか
    if (getters.isCategoryAdvanced && state.checkedArr.reibun.length === 0 && (state.checkedArr.katsuyo.length !== 0 || state.checkedArr.hanigo.length !== 0)) {
      Object.assign(params, { pageRanges: createRangeParam(getters.wasInputTangoRangePages) })
    }

  }

  // ID指定か
  if (getters.selectedRangeTypeIsMidashiId) {
    // 単語か例文か反意語が選択されているか
    if (getters.isShowPagesTango) {
      Object.assign(params, { codeRanges: createRangeParam(getters.wasInputTangoRangeMidashiIds) })
    }

    // 連語か例文か反意語が選択されているか
    if (getters.isShowPagesRengo) {
      Object.assign(params, { compoundCodeRanges: createRangeParam(getters.wasInputRengoRangeMidashiIds) })
    }

    // 応用問題で活用形のみか
    if (getters.isCategoryAdvanced || state.checkedArr.reibun.length === 0 && (state.checkedArr.katsuyo.length !== 0)) {
      Object.assign(params, { codeRanges: createRangeParam(getters.wasInputTangoRangeMidashiIds) })
    }
  }


  // テーマ別か
  if (getters.isCategoryTheme) {
    Object.assign(params, { themeIds: getters.selectedThemes.map(theme => theme.value) })
    if (getters.selectedRangeTypeIsUnit) Object.assign(params, { unitIds: getters.selectedUnits.map(unit => unit.value) })
  }

  return params
}



// パラメータのバリデーション mode = searchWord or createPrint
// searchWord  = 語数検索時
// createPrint = プリント作成時
const validate = (state, getters, mode) => {
  try {
    if(!state.selectedCategory)           throw '問題種別を選択してください'

    // 応用問題以外
    if (!getters.isCategoryAdvanced) {
      if (state.checkedArr.eiwa.length === 0) throw '英/和を選択してください'
    }

    //応用の場合
    if(getters.isCategoryAdvanced) {
      if(state.checkedArr.reibun.length===0 && state.checkedArr.katsuyo.length===0 && state.checkedArr.hanigo.length === 0) throw '例文問題・活用問題・反意語問題のいずれかを選択してください'
      // 例文が選択されていて、単語/連語未選択か
      if (state.checkedArr.reibun.length !== 0 && state.checkedArr.target.length === 0) throw '単語/連語を選択してください'
      // 反意語が選択されていて、単語/連語未選択か
      if (state.checkedArr.hanigo.length !== 0 && state.checkedArr.target.length === 0) throw '単語/連語を選択してください'
      // 例文が選択されていて、和英未選択か
      if (state.checkedArr.reibun.length !== 0 && state.checkedArr.eiwa.length === 0) throw '英/和を選択してください'
    }

    if(!state.selectedQuestionRangeType)    throw '範囲種別を選択してください'

    // ページ指定
    if(getters.selectedRangeTypeIsPage) {
      // 単語か例文が選択されている場合
      if (getters.isShowPagesTango) {
        if(getters.wasInputTangoRangePages.length === 0) throw '単語のページ範囲を入力してください'
        if(getters.wasInputTangoRangePages.filter(page => page.start > page.end).length >= 1) throw '単語のページ範囲の開始ページは終了ページより小さい値を入力してください'
      }

      // 連語か例文が選択されている場合
      if (getters.isShowPagesRengo) {
        if(getters.wasInputRengRangePages.length === 0) throw '連語のページ範囲を入力してください'
        if(getters.wasInputRengRangePages.filter(page => page.start > page.end).length >= 1) throw '連語のページ範囲の開始ページは終了ページより小さい値を入力してください'
      }

      // 応用問題で活用形のみか
      if (getters.isCategoryAdvanced && state.checkedArr.reibun.length === 0 && state.checkedArr.katsuyo.length !== 0 && state.checkedArr.hanigo.length === 0) {
        if(getters.wasInputTangoRangePages.length === 0) throw '単語のページ範囲を入力してください'
        if(getters.wasInputTangoRangePages.filter(page => page.start > page.end).length >= 1) throw '単語のページ範囲の開始ページは終了ページより小さい値を入力してください'
      }
    }

    // 見出し番号指定
    if(getters.selectedRangeTypeIsMidashiId) {
      // 単語か例文が選択されている場合
      if (getters.isShowPagesTango) {
        if(getters.wasInputTangoRangeMidashiIds.length === 0) throw '単語の見出し番号範囲を入力してください'
        if(getters.wasInputTangoRangeMidashiIds.filter(page => page.start > page.end).length >= 1) throw '単語の見出し範囲の開始番号は終了番号より小さい値を入力してください'
      }

      // 連語か例文が選択されている場合
      if (getters.isShowPagesRengo) {
        if(getters.wasInputRengoRangeMidashiIds.length === 0) throw '連語の見出し番号範囲を入力してください'
        if(getters.wasInputRengoRangeMidashiIds.filter(page => page.start > page.end).length >= 1) throw '連語の見出し範囲の開始番号は終了番号より小さい値を入力してください'
      }

      // 応用問題で活用形のみか
      if (getters.isCategoryAdvanced && state.checkedArr.reibun.length === 0 && state.checkedArr.katsuyo.length !== 0 && state.checkedArr.hanigo.length === 0) {
        if(getters.wasInputTangoRangeMidashiIds.length === 0) throw '単語の見出し番号範囲を入力してください'
        if(getters.wasInputTangoRangeMidashiIds.filter(page => page.start > page.end).length >= 1) throw '単語の見出し範囲の開始番号は終了番号より小さい値を入力してください'
      }
    }

    if(getters.isCategoryTheme) {
      if(getters.selectedThemes.length === 0) throw 'テーマを選択してください'
      if(getters.selectedRangeTypeIsUnit && getters.selectedUnits.length === 0) throw '単元を選択してください'
    }

    // 語数検索時はここまで
    if (mode === 'searchWord') return { status: 'success', message: '' }

    const nonErrorQuestionAreas = Object.entries(state.questionNumAreas)
      .some(([, attribute]) => attribute.displayFlg && ((attribute.value !== '0' && attribute.value !== 0) && !attribute.value))

    if(nonErrorQuestionAreas) throw '設問数を設定してください'

    const totalCount = Object.entries(state.questionNumAreas)
      .filter(([, attribute]) => attribute.displayFlg)
      .reduce((sum, [, attribute]) => sum + attribute.value, 0)
    if(totalCount < 10) throw '最低設問数10問に満たないためテストを作成できません'

    if(totalCount > 200) throw '設問数はトータル200問以内になるように入力してください'

    if (getters.isCategoryAdvanced && state.checkedArr.hanigo.length !== 0) {
      const hanigoTotal = state.questionNumAreas.headwordOpposite.value + state.questionNumAreas.compoundOpposite.value
      if(hanigoTotal < 5) throw '反意語の最低設問数５問に満たないためテストを作成できません'
    }

    if(!state.selectedQuestionSortType) throw 'ソート順を選択してください'

    if(!state.selectedQuestionDescription) throw '解説のあり・なしを選択してください'

    if(!state.printTitle) throw 'プリント名を入力しください'

    if(state.printTitle.length > 20) throw 'プリント名は20文字以内で入力してください'

  } catch (e) {
    return { status: 'error', message: e }
  }
  return { status: 'success', message: '' }
}

export default {
  createApiConditionParam: createApiConditionParam,
  validate: validate
}
